import React, { useContext } from 'react';

import { PhoneNumberInput as PhoneNumberInputComponent } from '../../../components/ui/Inputs/PhoneNumberInput';
import { SignUpFormContext } from '../SignUpFormContext';
import { useFieldErrorAnalytics } from '../useFieldErrorAnalytics';

export function PhoneNumberInput() {
  const { bindPhoneNumber, isLoading, invalidFields } = useContext(SignUpFormContext);
  useFieldErrorAnalytics({ field: 'phoneNumber', invalidFields });

  return (
    <PhoneNumberInputComponent
      name='phoneNumber'
      invalidFields={invalidFields}
      disabled={isLoading}
      {...bindPhoneNumber}
    />
  );
}
